import React, { useState, useEffect, useMemo } from 'react'
import './reports-and-statistics.css'
import { HeaderHLPure, SimpleLoading } from '../../pures';
import { Container, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { AgeAndGenderGraph, CPChoroplethMap, DailyGraph, DashboardDateFilter, HourlyGraph, TicketVolumeGraph, StatCard, UsageStatistics } from '../../pures/dashboard';
import moment from 'moment'

function ReportsAndStatisticsView(props) {
    const {
        isLoading,
        dates,
        handleChangeDate,
        handleSearch,
        data,
        periodType
    } = props;

    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' });
    const { t: tCommon } = useTranslation('common');

    const [days, setDays] = useState([])
    const [longDays, setLongDays] = useState([])
    const [months, setMonths] = useState([])
    const [longMonths, setLongMonths] = useState([])

    useEffect(() => {
        moment.locale(i18n.language === 'en' ? 'en' : 'es')
        setDays(moment.weekdaysShort())
        setLongDays(moment.weekdays())
        setMonths(moment.monthsShort())
        setLongMonths(moment.months())
    }, [i18n.language])

    const { tickFormat, tickLongFormat } = useMemo(() => {
        let tickFormat = null;
        let tickLongFormat = null;

        if (periodType === 'year') {
            tickFormat = months
            tickLongFormat = longMonths
        } else if (periodType === 'week') {
            tickFormat = days
            tickLongFormat = longDays
        }

        return { tickFormat, tickLongFormat }
    }, [periodType, months, days])

    return (
        <>
            {isLoading
                ? <div className='loading'>
                    <SimpleLoading />
                </div>
                : (<div className={"dashboardView"}>
                    <Container>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <HeaderHLPure title={t("title")} />
                            </Grid>

                            <Grid item xs={12} className="reportsAndStatisticsView-dashboard">
                                <div className='rasd-stats'>
                                    {/* DATE FILTER */}
                                    <DashboardDateFilter dates={dates} handleChangeDate={handleChangeDate} handleSearch={handleSearch} />

                                    {/* NICHE */}
                                    <StatCard
                                        title={t("niche")}
                                        value={tCommon(data?.niche)}
                                    />

                                    {/* AVERAGE AGE */}
                                    <StatCard
                                        title={t("averageAge")}
                                        value={data?.averageAge ? <>{data.averageAge.toFixed(0)} <span>{t("years")}</span></> : "N/D"}
                                    />

                                    {/* AVERAGE TOTAL */}
                                    <StatCard
                                        title={t("averageTotal")}
                                        value={data?.averageAmount ? <>${data.averageAmount.toFixed(2)} <span class="small-value">/{t("month")}</span></> : "N/D"}
                                    />
                                </div>
                                <div className='rasd-map dashboard-graph-card'>
                                    <p className="dashboardView-card-title">{t("consumerConcentration")}</p>
                                    <CPChoroplethMap data={data?.mapData} t={t} />
                                </div>
                                <div className="rasd-age">
                                    <AgeAndGenderGraph title={t("ageAndGender")} data={data?.genderAndAge} />
                                </div>

                                <TicketVolumeGraph
                                    data={data?.ticket_volume}
                                    prevData={data?.ticket_volume_prev}
                                    tickFormat={tickFormat}
                                    tickLongFormat={tickLongFormat}
                                    periodType={periodType}
                                    startDate={dates.startDate}
                                />

                                <DailyGraph data={data?.daily} days={days} longDays={longDays} />

                                <HourlyGraph data={data?.hourly} />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <UsageStatistics t={t}
                                    title={t("activeOffers")}
                                    progressValue={data?.offers_percentage}
                                    progressLabel={t("ofBusinessesPublished", { type: t("offers").toLowerCase() })}
                                    values={data?.avg_offers}
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <UsageStatistics t={t}
                                    title={t("activeSurveys")}
                                    progressValue={data?.surveys_percentage}
                                    progressLabel={t("ofBusinessesPublished", { type: t("surveys").toLowerCase() })}
                                    values={data?.avg_surveys}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                </div>)
            }
        </>
    )
}

export default ReportsAndStatisticsView